import { AsyncComponent } from '@frontend/components/mobile';
import { lazy } from 'react';
import { Navigate, Route } from 'react-router-dom';

import { DeceasedRoutes } from '../deceased/deceased-routes';
import { ActivityRoutes } from './activity/activity-routes';

const MyHome = lazy(() => import('./home/home.component'));
const MyNivalizTransactionDetail = lazy(() => import('./my-nivaliz/my-nivaliz-transaction-detail/my-nivaliz-transaction-detail.component'));

export function MyRoutes() {
    const activityRoutes = ActivityRoutes();
    const deceasedRoutes = DeceasedRoutes();
    return (
        <Route path='my'>
            <Route
                index
                element={<Navigate to='home' />}
            />
            <Route path='home'>
                <Route
                    index
                    element={
                        <AsyncComponent>
                            <MyHome />
                        </AsyncComponent>
                    }
                />
            </Route>
            <Route path='nivaliz'>
                <Route path=':transactionId'>
                    <Route
                        path='detail'
                        element={
                            <AsyncComponent>
                                <MyNivalizTransactionDetail />
                            </AsyncComponent>
                        }
                    />
                </Route>
            </Route>

            {activityRoutes}
            {deceasedRoutes}
        </Route>
    );
}
